/* SACHI.LA accessibility fixes for the Emerge 6.3.1 theme.
   Adds names, roles and states the theme's div-based controls are missing.
   IDs refer to SACHI.LA-accessibility-audit-2026-09-29.md. */
(function () {
  'use strict';

  var DRAWER_LABELS = { 'y-menu': 'Menu', search: 'Search', 'cart-drawer': 'Cart', 'product-form': 'Product options', pickup: 'Pickup availability' };

  function isVisible(el) {
    if (!el) return false;
    var cs = window.getComputedStyle(el);
    var rect = el.getBoundingClientRect();
    // Closed Emerge drawers keep their layout width but collapse to a 0x0 box.
    return cs.visibility !== 'hidden' && cs.display !== 'none' && rect.width > 0 && rect.height > 0;
  }

  // Make a div act like a button: role, focusability, and Space/Enter activation.
  function asButton(el, label) {
    if (!el || el.dataset.a11yButton) return;
    el.dataset.a11yButton = '1';
    el.setAttribute('role', 'button');
    if (label && !el.getAttribute('aria-label')) el.setAttribute('aria-label', label);
    if (el.tabIndex < 0) el.tabIndex = 0;
    el.addEventListener('keydown', function (e) {
      if (e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        el.click();
      }
    });
  }

  // A4, A5, A6: header controls.
  function fixHeader() {
    document.querySelectorAll('header a[href*="customer_authentication"], header a[href*="/account"]').forEach(function (a) {
      if (!a.textContent.trim() && !a.getAttribute('aria-label')) a.setAttribute('aria-label', 'Account');
    });
    document.querySelectorAll('[data-drawer-open][data-drawer-view="y-menu"]').forEach(function (el) {
      asButton(el, 'Menu');
      el.removeAttribute('aria-haspopup');
      el.setAttribute('aria-expanded', 'false');
    });
    document.querySelectorAll('.header--search').forEach(function (el) { asButton(el, 'Search'); });
    document.querySelectorAll('.header--cart-toggle').forEach(function (el) { el.removeAttribute('aria-haspopup'); });
  }

  // A7, A8: drawers become labelled dialogs that hold focus while open.
  function fixDrawers() {
    document.querySelectorAll('.drawer--container').forEach(function (c) {
      var view = c.getAttribute('data-view');
      c.setAttribute('role', 'dialog');
      if (DRAWER_LABELS[view]) c.setAttribute('aria-label', DRAWER_LABELS[view]);
    });
    document.querySelectorAll('.drawer--close').forEach(function (el) { asButton(el, 'Close'); });
  }

  // Closed drawers collapse to 0x0 but stay in the accessibility tree; only the open
  // one is modal, and closed ones are hidden so screen readers don't wander into them.
  function syncDrawers() {
    document.querySelectorAll('.drawer--container').forEach(function (c) {
      if (isVisible(c)) {
        c.setAttribute('aria-modal', 'true');
        c.removeAttribute('aria-hidden');
      } else {
        c.removeAttribute('aria-modal');
        c.setAttribute('aria-hidden', 'true');
      }
    });
    // The theme puts aria-expanded on the drawer wrapper div, where it isn't allowed.
    // Its CSS also uses that attribute to slide the drawer in, so keep the open state in
    // data-a11y-open (a11y-fixes.css styles from it) before removing the attribute.
    document.querySelectorAll('.drawer--instance[aria-expanded]').forEach(function (el) {
      el.setAttribute('data-a11y-open', el.getAttribute('aria-expanded'));
      el.removeAttribute('aria-expanded');
    });
  }

  function syncExpanded() {
    syncDrawers();
    var menu = document.querySelector('.drawer--container[data-view="y-menu"]');
    var open = isVisible(menu) ? 'true' : 'false';
    document.querySelectorAll('[data-drawer-open][data-drawer-view="y-menu"]').forEach(function (el) {
      el.setAttribute('aria-expanded', open);
    });
  }

  function openDrawer() {
    var list = document.querySelectorAll('.drawer--container');
    for (var i = 0; i < list.length; i++) if (isVisible(list[i])) return list[i];
    return null;
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var drawer = openDrawer();
    if (!drawer) return;
    var root = drawer.closest('drawer-root') || drawer;
    var items = Array.prototype.filter.call(
      root.querySelectorAll('a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])'),
      function (el) { return isVisible(el) && !el.disabled; }
    );
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (!root.contains(document.activeElement)) {
      e.preventDefault();
      first.focus();
    } else if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  // A8: cart quantity steppers.
  function fixQuantity(scope) {
    (scope || document).querySelectorAll('.quantity-selector--plus').forEach(function (el) { asButton(el, 'Increase quantity'); });
    (scope || document).querySelectorAll('.quantity-selector--minus').forEach(function (el) { asButton(el, 'Decrease quantity'); });
  }

  // A9: product image zoom and thumbnails.
  function fixProductMedia(scope) {
    (scope || document).querySelectorAll('product-zoom-root, .product-zoom--root').forEach(function (el) { asButton(el, 'Enlarge product image'); });
    (scope || document).querySelectorAll('.product-media--thumb, [data-item="thumbnail"]').forEach(function (el, i, all) {
      if (el.tabIndex >= 0 && el.tagName !== 'BUTTON' && el.tagName !== 'A') asButton(el, 'View image ' + (i + 1) + ' of ' + all.length);
    });
  }

  // A3: scrolling banner. One tab stop, a named link, and a pause button.
  function fixMarquee() {
    document.querySelectorAll('.scrolling-content--root').forEach(function (root) {
      if (root.dataset.a11yMarquee) return;
      root.dataset.a11yMarquee = '1';
      var links = root.querySelectorAll('a');
      var kept = false;
      links.forEach(function (a) {
        var isText = !!a.querySelector('[data-item="section-heading"]');
        if (isText && !kept) {
          kept = true;
          var text = a.textContent.replace(/\s+/g, ' ').trim();
          a.setAttribute('aria-label', text + (a.target === '_blank' ? ' (opens in a new tab)' : ''));
        } else {
          a.setAttribute('aria-hidden', 'true');
          a.tabIndex = -1;
        }
      });
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'a11y-marquee-toggle';
      btn.textContent = 'Pause';
      btn.setAttribute('aria-pressed', 'false');
      btn.setAttribute('aria-label', 'Pause scrolling banner');
      btn.addEventListener('click', function () {
        var paused = root.classList.toggle('a11y-paused');
        btn.textContent = paused ? 'Play' : 'Pause';
        btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        btn.setAttribute('aria-label', paused ? 'Play scrolling banner' : 'Pause scrolling banner');
      });
      root.appendChild(btn);
    });
  }

  // A11, A12: one H1 per page and no skipped heading levels.
  function fixHeadings() {
    var main = document.querySelector('main') || document.getElementById('MainContent') || document.body;
    if (!main.querySelector('h1, [role="heading"][aria-level="1"]')) {
      var candidates = Array.prototype.filter.call(
        main.querySelectorAll('.featured-content--title, .cart--title, .featured-grid--heading, .collection--title, .page--title'),
        function (el) { return !el.closest('.drawer--container'); }
      );
      if (candidates.length) {
        // The cart renders separate empty/filled titles and shows one; promote every
        // title of the first match's type so whichever is visible is the H1.
        var type = candidates[0].className.split(' ')[0];
        candidates.forEach(function (el) {
          if (el.classList.contains(type)) {
            el.setAttribute('role', 'heading');
            el.setAttribute('aria-level', '1');
          }
        });
      } else if (document.body.className.indexOf('template--search') !== -1) {
        var h1 = document.createElement('h1');
        h1.className = 'a11y-visually-hidden';
        h1.textContent = 'Search results';
        main.insertBefore(h1, main.firstChild);
      }
    }
    // Close any skipped levels (e.g. H1 -> H3 on the 404 page and collection list).
    var prev = 0;
    main.querySelectorAll('h1, h2, h3, h4, h5, h6, [role="heading"]').forEach(function (h) {
      if (h.closest('.drawer--container, [aria-hidden="true"]')) return;
      var level = parseInt(h.getAttribute('aria-level') || h.tagName.slice(1), 10) || 2;
      if (prev && level > prev + 1) {
        level = prev + 1;
        h.setAttribute('role', 'heading');
        h.setAttribute('aria-level', String(level));
      }
      prev = level;
    });
  }

  // A14: founders photo on About Us (decorative daffodil banner stays empty alt).
  function fixAltText() {
    document.querySelectorAll('img').forEach(function (img) {
      if (img.alt) return;
      var src = img.currentSrc || img.src || '';
      if (src.indexOf('IMG_1779edit') !== -1) {
        img.alt = 'Sisters Sachi and Chiyo smiling behind the SACHI.LA coffee bar';
      }
    });
  }

  // A18: sold-out options are only shown with a strike line; say it in words too.
  function fixSoldOut() {
    document.querySelectorAll('.radios--input').forEach(function (input) {
      var label = input.nextElementSibling;
      if (!label || !label.classList.contains('radios--value-button')) return;
      var note = label.querySelector('.a11y-soldout');
      var empty = input.getAttribute('data-empty') === 'true';
      if (empty && !note) {
        note = document.createElement('span');
        note.className = 'a11y-visually-hidden a11y-soldout';
        note.textContent = ', sold out';
        (label.firstElementChild || label).appendChild(note);
      } else if (!empty && note) {
        note.remove();
      }
    });
  }

  // A19: third-party checkout button frames (PayPal) arrive without a title.
  function fixFrameTitles() {
    document.querySelectorAll('iframe:not([title]), iframe[title=""]').forEach(function (f) {
      if (f.closest('.paypal-buttons')) f.setAttribute('title', 'PayPal checkout');
      else if (f.closest('.shopify-payment-button')) f.setAttribute('title', 'Express checkout');
    });
  }

  function run(scope) {
    fixHeader();
    fixDrawers();
    fixQuantity(scope);
    fixProductMedia(scope);
    fixMarquee();
    fixHeadings();
    fixAltText();
    fixSoldOut();
    fixFrameTitles();
    syncExpanded();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { run(); });
  } else {
    run();
  }

  // The theme re-renders the cart drawer and product forms; re-apply after insertions.
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(function () {
      pending = false;
      run();
    });
  }).observe(document.body, { childList: true, subtree: true });

  // The theme sets aria-expanded true/false on drawer wrappers as they open and close; mirror it to data-a11y-open and strip it each time.
  var drawerRoot = document.querySelector('drawer-root');
  if (drawerRoot) {
    new MutationObserver(function (records) {
      records.forEach(function (r) {
        if (r.target.classList && r.target.classList.contains('drawer--instance') && r.target.hasAttribute('aria-expanded')) {
          r.target.setAttribute('data-a11y-open', r.target.getAttribute('aria-expanded'));
          r.target.removeAttribute('aria-expanded');
        }
      });
    }).observe(drawerRoot, { attributes: true, subtree: true, attributeFilter: ['aria-expanded'] });
  }

  // Picking one option can sell out another (data-empty flips without new nodes).
  document.addEventListener('change', function () {
    window.setTimeout(fixSoldOut, 50);
  });

  // Drawers open and close via the theme's own handlers; check a few times so the
  // state is right after the open/close animation settles.
  ['click', 'keyup'].forEach(function (type) {
    document.addEventListener(type, function () {
      [100, 500, 1000].forEach(function (ms) { window.setTimeout(syncExpanded, ms); });
    });
  });
})();
